(function () {
  'use strict';

  var resizeFrame = null;
  var lockState = null;

  function getHeaderHeight() {
    var selectors = [
      'sticky-header',
      'header.shopify-section-header-sticky',
      'header[class*="sticky"]',
      '.header-wrapper--sticky',
      '#shopify-section-header',
      'header'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var element = document.querySelector(selectors[i]);

      if (element) {
        var rect = element.getBoundingClientRect();

        if (rect.bottom > 0 && rect.height > 0) {
          return Math.round(rect.height);
        }
      }
    }

    return 0;
  }

  function lockBody() {
    if (lockState) return;

    var html = document.documentElement;
    var body = document.body;

    lockState = {
      htmlOverflow: html.style.overflow,
      htmlPosition: html.style.position,
      bodyOverflow: body.style.overflow
    };

    html.style.overflow = 'hidden';
    html.style.position = 'relative';
    body.style.overflow = 'hidden';
  }

  function unlockBody() {
    if (!lockState) return;

    var html = document.documentElement;
    var body = document.body;

    html.style.overflow = lockState.htmlOverflow;
    html.style.position = lockState.htmlPosition;
    body.style.overflow = lockState.bodyOverflow;

    lockState = null;
  }

  function getFocusableElements(dialog) {
    var elements = dialog.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), ' +
      'select:not([disabled]), textarea:not([disabled]), ' +
      '[tabindex]:not([tabindex="-1"])'
    );

    return Array.prototype.filter.call(elements, function (element) {
      return (
        element.offsetParent !== null &&
        element.getAttribute('aria-hidden') !== 'true'
      );
    });
  }

  function initQG(wrap) {
    if (!wrap || wrap.dataset.qgInitialized === 'true') return;

    var id = wrap.dataset.qgId;
    var dialog = document.getElementById('qg-dialog-' + id);
    var openBtn = wrap.querySelector('.qg-bar__link');
    var overlay = dialog
      ? dialog.querySelector('.qg-dialog__overlay')
      : null;
    var closeBtn = dialog
      ? dialog.querySelector('.qg-modal__close')
      : null;

    if (!dialog || !openBtn || !overlay || !closeBtn) return;

    wrap.dataset.qgInitialized = 'true';

    var closeTimer = null;

    function setHeaderOffset() {
      var height = window.innerWidth <= 749
        ? 0
        : getHeaderHeight();

      dialog.style.setProperty(
        '--qg-header-height',
        height + 'px'
      );
    }

    function openModal() {
      if (dialog.classList.contains('is-open')) return;

      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }

      setHeaderOffset();
      lockBody();

      dialog.classList.remove('is-closing');
      dialog.classList.add('is-open');
      dialog.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');

      window.requestAnimationFrame(function () {
        try {
          closeBtn.focus({ preventScroll: true });
        } catch (error) {
          closeBtn.focus();
        }
      });
    }

    function closeModal(immediate) {
      if (!dialog.classList.contains('is-open')) return;

      dialog.classList.remove('is-open');
      dialog.classList.add('is-closing');
      dialog.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');

      function finishClose() {
        closeTimer = null;
        dialog.classList.remove('is-closing');
        unlockBody();

        try {
          openBtn.focus({ preventScroll: true });
        } catch (error) {
          openBtn.focus();
        }
      }

      if (
        immediate === true ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        finishClose();
      } else {
        closeTimer = window.setTimeout(finishClose, 300);
      }
    }

    function handleKeydown(event) {
      if (!dialog.classList.contains('is-open')) return;

      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = getFocusableElements(dialog);

      if (!focusable.length) {
        event.preventDefault();
        closeBtn.focus();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (
        event.shiftKey &&
        document.activeElement === first
      ) {
        event.preventDefault();
        last.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === last
      ) {
        event.preventDefault();
        first.focus();
      }
    }

    function handleOverlayClick() {
      closeModal();
    }

    function handleCloseClick() {
      closeModal();
    }

    openBtn.addEventListener('click', openModal);
    overlay.addEventListener('click', handleOverlayClick);
    closeBtn.addEventListener('click', handleCloseClick);
    dialog.addEventListener('keydown', handleKeydown);

    wrap._qgCleanup = function () {
      openBtn.removeEventListener('click', openModal);
      overlay.removeEventListener('click', handleOverlayClick);
      closeBtn.removeEventListener('click', handleCloseClick);
      dialog.removeEventListener('keydown', handleKeydown);

      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }

      if (dialog.classList.contains('is-open')) {
        closeModal(true);
      } else if (dialog.classList.contains('is-closing')) {
        dialog.classList.remove('is-closing');
        unlockBody();
      }

      delete wrap.dataset.qgInitialized;
      delete wrap._qgCleanup;
    };
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll
      ? scope
      : document;

    var wraps = root.matches &&
      root.matches('[data-qg-id]')
      ? [root]
      : root.querySelectorAll('[data-qg-id]');

    Array.prototype.forEach.call(wraps, initQG);
  }

  function handleResize() {
    if (resizeFrame) {
      window.cancelAnimationFrame(resizeFrame);
    }

    resizeFrame = window.requestAnimationFrame(function () {
      resizeFrame = null;

      var dialog = document.querySelector('.qg-dialog.is-open');
      if (!dialog) return;

      var height = window.innerWidth <= 749
        ? 0
        : getHeaderHeight();

      dialog.style.setProperty(
        '--qg-header-height',
        height + 'px'
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  window.addEventListener('resize', handleResize, { passive: true });
  window.addEventListener('orientationchange', handleResize, { passive: true });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var wraps = event.target.matches &&
      event.target.matches('[data-qg-id]')
      ? [event.target]
      : event.target.querySelectorAll('[data-qg-id]');

    Array.prototype.forEach.call(wraps, function (wrap) {
      if (typeof wrap._qgCleanup === 'function') {
        wrap._qgCleanup();
      }
    });
  });
})();